


































































import {Component} from "vue-property-decorator";
import {ComplaintStore} from "@/modules/complaint/store";
import {ComplaintParams} from "@/modules/complaint/params";
import {CommonMixin} from "@/shared/services/mixin";
import ComplaintStatusLabel from "@/shared/components/ComplaintStatusLabel/index.vue";
import ComplaintSearch from "@/modules/complaint/List/components/Search.vue";
import ComplaintTableAction from "@/modules/complaint/List/components/TableAction.vue";
import {mixins} from "vue-class-component";
import {ComplaintStatus} from "@/enums/status";
import moment from "moment";
import {FORMAT_DATE_TIME_PICKER, PAGE_SIZE_OPTIONS} from "@/shared/constant";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";

@Component({
    name: "ComplaintList",
    components: {TooltipLabel, ComplaintTableAction, ComplaintSearch, ComplaintStatusLabel}
})
export default class extends mixins(CommonMixin) {
    moment = moment;
    FORMAT_DATE_TIME_PICKER = FORMAT_DATE_TIME_PICKER;
    columns = [
        {
            title: "Xử lý",
            dataIndex: "id",
            key: "action",
            scopedSlots: {customRender: "action"},
            width: 80,
            align: "center"
        },
        {
            title: "Ngày, giờ nhận gửi",
            dataIndex: "billLading.dateOfAcceptance",
            key: "billLadingCreatedDate",
            scopedSlots: {customRender: "dateOfAcceptance"},
            width: 150,
            ellipsis: true
        },
        {
            title: "Ngày, giờ khiếu nại",
            dataIndex: "createdDate",
            key: "createdDate",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: "createdDate"}
        },
        {
            title: "Mã vận đơn",
            dataIndex: "billLading.ladingCode",
            key: "billLadingRowGuid",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: "ladingCode"}
        },
        {
            title: "Nội dung khiếu lại",
            dataIndex: "content",
            key: "content",
            width: 300,
            ellipsis: true,
            scopedSlots: {customRender: "content"}
        },
        {
            title: "Nội dung trả lời",
            dataIndex: "answer",
            key: "answer",
            width: 200,
            ellipsis: true,
            scopedSlots: {customRender: "answer"}
        },
        {
            title: "SĐT người gửi",
            dataIndex: "billLading.customer.phoneNumber",
            key: "phoneNumber",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: "senderPhone"}
        },
        {
            title: "Đại diện gửi",
            dataIndex: "billLading.customer.fullName",
            key: "customerName",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: "senderName"}
        },
        {
            title: "Mã khách hàng",
            dataIndex: "billLading.customer.customerCode",
            key: "customerCode",
            width: 120,
            ellipsis: true
        },
        {
            title: "Người tạo khiếu nại",
            dataIndex: "createdBy",
            key: "createdBy",
            scopedSlots: {customRender: "createdBy"},
            width: 180,
            ellipsis: true
        },
        {
            title: "DVKH Tiếp nhận",
            dataIndex: "receiveEmployee.fullname",
            key: "receiveEmployee",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: "receiveEmployeeName"}
        },
        {
            title: "DVKH được giao xử lý",
            dataIndex: "handlingEmployee.fullname",
            key: "handlingEmployee",
            width: 180,
            ellipsis: true,
            scopedSlots: {customRender: "handlingEmployeeName"}
        },
        {
            title: "Trạng thái xử lý",
            dataIndex: "status",
            key: "status",
            scopedSlots: {customRender: "status"},
            width: 120,
            ellipsis: true
        },
    ];
    json_fields = {
        "Ngày, giờ khiếu nại": "createdDate",
        "Mã vận đơn": "billLading.ladingCode",
        "Số điện thoại người gửi": "billLading.customer.phoneNumber",
        "Đại diện gửi": "billLading.customer.fullName",
        "Mã khách hàng": "billLading.customer.customerCode",
        "Nội dung khiếu nại": "content",
        "Nội dung trả lời": "answer",
        "DVKH tiếp nhận": "receiveEmployee.fullname",
        "DVKH được giao xử lý": "handlingEmployee.fullname",
        "Trạng thái xử lý": {
            field: "status",
            callback: (value) => {
                return this.$t(`ComplaintStatus.${ComplaintStatus[value]}`);
            }
        },
    };

    get complaints() {
        return ComplaintStore.complaints;
    }

    created() {
        ComplaintStore.listComplaint(new ComplaintParams())
    }

    get pagination() {
        return {
            current: ComplaintStore.meta.page,
            pageSize: ComplaintStore.meta.limit,
            total: ComplaintStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} khiếu nại`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        ComplaintStore.listComplaint({...ComplaintStore.params, page: pagination.current, limit: pagination.pageSize});
    }

}


